// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2EnrollmentFlags {
    static getAttributeTypeMap() {
        return EnrollmentV2EnrollmentFlags.attributeTypeMap;
    }
}
EnrollmentV2EnrollmentFlags.discriminator = undefined;
EnrollmentV2EnrollmentFlags.additionalProperties = false;
EnrollmentV2EnrollmentFlags.attributeTypeMap = [
    {
        "name": "lastOneOrMoreDays",
        "baseName": "lastOneOrMoreDays",
        "type": "boolean"
    },
    {
        "name": "isActiveEnrollmentForCurrentDate",
        "baseName": "isActiveEnrollmentForCurrentDate",
        "type": "boolean"
    },
];
//# sourceMappingURL=enrollmentV2EnrollmentFlags.js.map